import { useCallback, useEffect, useRef, useState } from 'react';
import { LEFT_ELEMENT_GAP } from './consts';
export const useAccordion = ({
  defaultClosed,
  onClick
}) => {
  const [open, setOpen] = useState(!defaultClosed);
  const leftElemRef = useRef(null);
  const bodyRef = useRef(null);
  const contentRef = useRef(null);
  const [contentHeight, setContentHeight] = useState(0);
  useEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, []);
  const [bodyHeight, setBodyHeight] = useState(!defaultClosed ? contentHeight : 0);
  useEffect(() => {
    setBodyHeight(open ? contentHeight : 0);
  }, [contentHeight, open]);
  useEffect(() => {
    if (bodyRef.current) {
      bodyRef.current.style.height = bodyHeight === 0 ? '0px' : `calc(${bodyHeight}px + var(--space-100)`;
    }
  }, [bodyHeight, open]);
  const [leftElemWidth, setLeftElemWidth] = useState(0);
  useEffect(() => {
    if (leftElemRef.current) {
      setLeftElemWidth(leftElemRef.current.offsetWidth + LEFT_ELEMENT_GAP);
    } else {
      setLeftElemWidth(0);
    }
  }, []);
  const handleClick = useCallback(() => {
    setOpen(!open);
    onClick == null ? void 0 : onClick(open);
  }, [open, onClick]);
  return {
    open,
    bodyRef,
    leftElemRef,
    contentRef,
    leftElemWidth,
    handleClick
  };
};